import { ALL_BUTTON_POSITION_LIST } from '@/common/manager/position/button-position';
import { executeFlowAction } from '@/common/util/util';
export const config = {
    value: 'flowAction',
    position: ALL_BUTTON_POSITION_LIST,
    action: async (config, ...otherArgs) => {
        const { buttonConfig, position, _context } = config || {};
        const { options } = buttonConfig || {};
        const { flowList } = options;
        if (Array.isArray(flowList) && flowList.length > 0) {
            if (_context?.state) {
                const flowDataKeys = Object.keys(_context.state.valueOf);
                if (Array.isArray(flowDataKeys) && flowDataKeys.length > 0) {
                    flowDataKeys.forEach((key) => {
                        if (key) {
                            if (!(key.includes('$$$') || key.startsWith('Cn'))) {
                                _context.state.valueOf[key] = undefined;
                            }
                        }
                    });
                }
            }
            return executeFlowAction({
                flowList,
                _context,
                position,
                config,
                otherArgs,
            });
            // try {
            // }catch (e){
            //   console.log('flow action run error', e);
            // }
        }
    },
};
